<app-loader [hideSpinner]="isDataLoaded"></app-loader>
<div [ngClass]="{ 'hidden': !isDataLoaded }" class="product-view-container" *ngIf="country">
    <nav class="product-header sticky-top navbar navbar-light bg-light" [ngClass]="{ 'im-dirty': isModified }">
        <span class="navbar-brand">Country View</span>
        <div class="navbar-nav mr-auto"></div>
        <button type="button" class="btn btn-secondary btn-cancel mr-1" (click)="cancel()">
			<span>Reset Form</span>
		</button>
		<button type="button" class="btn btn-primary btn-save mr-1" (click)="save()">
			<span>Save</span>
		</button>
		<button type="button" class="btn btn-danger btn-delete mr-1" (click)="delete()">
			<span>Delete</span>
		</button>
		<button *ngIf="country.active"  type="button" class="btn btn-warning btn-deactivate mr-1" (click)="deactivate()">
			<span>Deactivate</span>
		</button>
		<button *ngIf="!country.active" type="button" class="btn btn-primary btn-activate mr-1" (click)="activate()">
			<span>Activate</span>
		</button>
		<button mat-icon-button class="btn-close" (click)="back()">
			<mat-icon>close</mat-icon>
		</button>
    </nav>
    <div class="product-container">
        <mat-card>
            <div class="row">
                <div class="col-8">
                    <label>Country Name</label>
                    <div class="input-group mb-3">
                        <input [(ngModel)]="country.name" type="text" class="form-control" (input)="dataChanged()">
                    </div>
                    <label>Country Code</label>
                    <div class="input-group mb-3">
                        <input [(ngModel)]="country.code" type="text" class="form-control" (input)="dataChanged()">
                    </div>
                    <label>Currency Code</label>
					<select [(ngModel)]="country.currencyCode" name="currencyCode" class="custom-select" required>
						<option value="">Select a currency code</option>
						<option *ngFor="let currency of currencies" value="{{currency}}">{{currency}}</option>
					</select>
                    <label>Description</label>
                    <div class="input-group mb-3">
                        <textarea [(ngModel)]="country.description" class="form-control" rows="5"
                                  (input)="dataChanged()"></textarea>
                    </div>
                </div>
            </div>
        </mat-card>
    </div>
</div>
